<template>
  <v-chart ref="echarts" autoresize :options="configOptions" theme="ptom-echart-theme" />
</template>
<script>
import ECharts from 'vue-echarts'
import theme from './theme'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'

ECharts.registerTheme('ptom-echart-theme', theme)

export default {
  name: 'PipEchart',
  components: { VChart: ECharts },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    configOptions: {
      type: Object,
      required: true
    }
  },
  watch: {
    loading(nVal) {
      if (nVal) this.$refs.echarts.showLoading()
      else this.$refs.echarts.hideLoading()
    }
  }
}
</script>
<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 100%;

  ::v-deep .tooltop-span > span {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    border-radius: 10px;
  }
}
</style>
